import dayjs from 'dayjs'

export const isReminderSentToday = (emailSentDate?: string | null): boolean => {
  if (!emailSentDate) {
    return false
  }

  const sent = dayjs(emailSentDate)
  if (!sent.isValid()) {
    return false
  }

  return sent.isSame(dayjs(), 'day')
}
